module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_next_navy-7964308b84386ebaa567f11a42ee0303.svg";